var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMigration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fx0",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%",
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.4,
    intercept: 0
  })), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "1.77778 1.77778"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fx1",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%",
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.4,
    intercept: 0
  })), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "1.77778 1.77778"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 360,
    x2: 1280,
    y2: 360,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64B450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#64B450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4CA167",
    stopOpacity: 0.54902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#066BAA",
    stopOpacity: 0.301961
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1280,
    height: 720,
    fill: "url(#fill2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 496.5C92 473.58 112.595 455 138 455 163.405 455 184 473.58 184 496.5 184 519.42 163.405 538 138 538 112.595 538 92 519.42 92 496.5Z",
    stroke: "#000000",
    strokeWidth: 9.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 368C252 345.356 272.595 327 298 327 323.405 327 344 345.356 344 368 344 390.644 323.405 409 298 409 272.595 409 252 390.644 252 368Z",
    stroke: "#000000",
    strokeWidth: 9.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 216C257 193.356 277.595 175 303 175 328.405 175 349 193.356 349 216 349 238.644 328.405 257 303 257 277.595 257 257 238.644 257 216Z",
    stroke: "#000000",
    strokeWidth: 9.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 546C254 523.356 274.595 505 300 505 325.405 505 346 523.356 346 546 346 568.644 325.405 587 300 587 274.595 587 254 568.644 254 546Z",
    stroke: "#000000",
    strokeWidth: 9.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426 380C426 357.356 446.595 339 472 339 497.405 339 518 357.356 518 380 518 402.644 497.405 421 472 421 446.595 421 426 402.644 426 380Z",
    stroke: "#000000",
    strokeWidth: 9.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 300.5C92 277.58 112.595 259 138 259 163.405 259 184 277.58 184 300.5 184 323.42 163.405 342 138 342 112.595 342 92 323.42 92 300.5Z",
    stroke: "#000000",
    strokeWidth: 9.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 86.093 55.5146",
    stroke: "#000000",
    strokeWidth: 10.3333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 171 271.515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 330 267.301 516.999",
    stroke: "#000000",
    strokeWidth: 10.3333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 132.11 210.452",
    stroke: "#000000",
    strokeWidth: 10.3333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 270.11 245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 245 439.861 350.908",
    stroke: "#000000",
    strokeWidth: 10.3333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.499 380.138 344 368",
    stroke: "#000000",
    strokeWidth: 10.3333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 409 299.324 504.52",
    stroke: "#000000",
    strokeWidth: 10.3333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 301 252.021 368.364",
    stroke: "#000000",
    strokeWidth: 10.3333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.7438 53.6375 38.9688 53.6375C40.3494 53.6375 41.4688 52.5182 41.4688 51.1375 41.4688 49.7568 40.3494 48.6375 38.9688 48.6375L33.925 48.6375C36.7245 45.9066 36.7802 41.4234 34.0493 38.6239 32.7032 37.2439 30.8527 36.4724 28.925 36.4875 26.625 36.55 25.7063 37.4437 25.1125 37.625 24.6383 37.7346 24.1643 37.4418 24.05 36.9688 23.9744 36.5101 24.2374 36.0631 24.675 35.9062 28.8266 33.4736 34.1641 34.8671 36.5967 39.0186 36.9296 39.5866 37.1969 40.1906 37.3938 40.8187L41.8937 43.2 41.8937 45C41.8937 46.3807 43.0131 47.5 44.3937 47.5 45.7744 47.5 46.8937 46.3807 46.8937 45L46.8937 41.6937C46.9071 40.7797 46.4206 39.9313 45.625 39.4812L38.0063 35.4562C41.25 32.5938 44 30.8562 45 26.6562 45.261 25.0859 45.2036 23.479 44.8313 21.9312 44.8313 21.4929 45.1866 21.1375 45.625 21.1375L52.05 21.1375C52.4141 21.1331 52.7711 21.0363 53.0875 20.8562 55.2812 19.5688 55.3 16.8188 55.25 15.9625 55.2373 15.7966 55.1764 15.6381 55.075 15.5062L53.05 12.9625 53.05 12.9625C53.05 8.44375 49.375 5.55625 44.8562 5.54375 40.3904 5.45916 36.7016 9.01081 36.6171 13.4766 36.6114 13.7765 36.6224 14.0764 36.65 14.375 36.6917 14.9014 36.3695 15.3886 35.8688 15.5562 19.1187 21.4062 16.5437 34.7313 16.4 41.5375 14.8312 41.2812 14.8187 40.725 14.8187 39.9375L14.8187 18.6875C14.8187 15.9261 12.5802 13.6875 9.81875 13.6875 7.05731 13.6875 4.81875 15.9261 4.81875 18.6875L4.81875 21.425C4.81875 22.4606 5.65822 23.3 6.69375 23.3 7.72931 23.3 8.56875 22.4606 8.56875 21.425L8.56875 18.75C8.56875 18.0596 9.12838 17.5 9.81875 17.5 10.5091 17.5 11.0687 18.0596 11.0687 18.75L11.0687 40C11.0687 44.1625 14.1937 45.175 16.8 45.4187 18 49.925 22.0938 53.4937 30.9937 53.6875Z",
    fill: "#3B7D23",
    transform: "matrix(1.03333 0 0 1 272 190)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.7438 53.6375 38.9688 53.6375C40.3494 53.6375 41.4688 52.5182 41.4688 51.1375 41.4688 49.7568 40.3494 48.6375 38.9688 48.6375L33.925 48.6375C36.7245 45.9066 36.7802 41.4234 34.0493 38.6239 32.7032 37.2439 30.8527 36.4724 28.925 36.4875 26.625 36.55 25.7063 37.4437 25.1125 37.625 24.6383 37.7346 24.1643 37.4418 24.05 36.9688 23.9744 36.5101 24.2374 36.0631 24.675 35.9062 28.8266 33.4736 34.1641 34.8671 36.5967 39.0186 36.9296 39.5866 37.1969 40.1906 37.3938 40.8187L41.8937 43.2 41.8937 45C41.8937 46.3807 43.0131 47.5 44.3937 47.5 45.7744 47.5 46.8937 46.3807 46.8937 45L46.8937 41.6937C46.9071 40.7797 46.4206 39.9313 45.625 39.4812L38.0063 35.4562C41.25 32.5938 44 30.8562 45 26.6562 45.261 25.0859 45.2036 23.479 44.8313 21.9312 44.8313 21.4929 45.1866 21.1375 45.625 21.1375L52.05 21.1375C52.4141 21.1331 52.7711 21.0363 53.0875 20.8562 55.2812 19.5688 55.3 16.8188 55.25 15.9625 55.2373 15.7966 55.1764 15.6381 55.075 15.5062L53.05 12.9625 53.05 12.9625C53.05 8.44375 49.375 5.55625 44.8562 5.54375 40.3904 5.45916 36.7016 9.01081 36.6171 13.4766 36.6114 13.7765 36.6224 14.0764 36.65 14.375 36.6917 14.9014 36.3695 15.3886 35.8688 15.5562 19.1187 21.4062 16.5437 34.7313 16.4 41.5375 14.8312 41.2812 14.8187 40.725 14.8187 39.9375L14.8187 18.6875C14.8187 15.9261 12.5802 13.6875 9.81875 13.6875 7.05731 13.6875 4.81875 15.9261 4.81875 18.6875L4.81875 21.425C4.81875 22.4606 5.65822 23.3 6.69375 23.3 7.72931 23.3 8.56875 22.4606 8.56875 21.425L8.56875 18.75C8.56875 18.0596 9.12838 17.5 9.81875 17.5 10.5091 17.5 11.0687 18.0596 11.0687 18.75L11.0687 40C11.0687 44.1625 14.1937 45.175 16.8 45.4187 18 49.925 22.0938 53.4937 30.9937 53.6875Z",
    fill: "#C04F15",
    transform: "matrix(1.03333 0 0 1 441 353)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.7438 53.6375 38.9688 53.6375C40.3494 53.6375 41.4688 52.5182 41.4688 51.1375 41.4688 49.7568 40.3494 48.6375 38.9688 48.6375L33.925 48.6375C36.7245 45.9066 36.7802 41.4234 34.0493 38.6239 32.7032 37.2439 30.8527 36.4724 28.925 36.4875 26.625 36.55 25.7063 37.4437 25.1125 37.625 24.6383 37.7346 24.1643 37.4418 24.05 36.9688 23.9744 36.5101 24.2374 36.0631 24.675 35.9062 28.8266 33.4736 34.1641 34.8671 36.5967 39.0186 36.9296 39.5866 37.1969 40.1906 37.3938 40.8187L41.8937 43.2 41.8937 45C41.8937 46.3807 43.0131 47.5 44.3937 47.5 45.7744 47.5 46.8937 46.3807 46.8937 45L46.8937 41.6937C46.9071 40.7797 46.4206 39.9313 45.625 39.4812L38.0063 35.4562C41.25 32.5938 44 30.8562 45 26.6562 45.261 25.0859 45.2036 23.479 44.8313 21.9312 44.8313 21.4929 45.1866 21.1375 45.625 21.1375L52.05 21.1375C52.4141 21.1331 52.7711 21.0363 53.0875 20.8562 55.2812 19.5688 55.3 16.8188 55.25 15.9625 55.2373 15.7966 55.1764 15.6381 55.075 15.5062L53.05 12.9625 53.05 12.9625C53.05 8.44375 49.375 5.55625 44.8562 5.54375 40.3904 5.45916 36.7016 9.01081 36.6171 13.4766 36.6114 13.7765 36.6224 14.0764 36.65 14.375 36.6917 14.9014 36.3695 15.3886 35.8688 15.5562 19.1187 21.4062 16.5437 34.7313 16.4 41.5375 14.8312 41.2812 14.8187 40.725 14.8187 39.9375L14.8187 18.6875C14.8187 15.9261 12.5802 13.6875 9.81875 13.6875 7.05731 13.6875 4.81875 15.9261 4.81875 18.6875L4.81875 21.425C4.81875 22.4606 5.65822 23.3 6.69375 23.3 7.72931 23.3 8.56875 22.4606 8.56875 21.425L8.56875 18.75C8.56875 18.0596 9.12838 17.5 9.81875 17.5 10.5091 17.5 11.0687 18.0596 11.0687 18.75L11.0687 40C11.0687 44.1625 14.1937 45.175 16.8 45.4187 18 49.925 22.0938 53.4937 30.9937 53.6875Z",
    transform: "matrix(1.05 0 0 1 264 339)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.7438 53.6375 38.9688 53.6375C40.3494 53.6375 41.4688 52.5182 41.4688 51.1375 41.4688 49.7568 40.3494 48.6375 38.9688 48.6375L33.925 48.6375C36.7245 45.9066 36.7802 41.4234 34.0493 38.6239 32.7032 37.2439 30.8527 36.4724 28.925 36.4875 26.625 36.55 25.7063 37.4437 25.1125 37.625 24.6383 37.7346 24.1643 37.4418 24.05 36.9688 23.9744 36.5101 24.2374 36.0631 24.675 35.9062 28.8266 33.4736 34.1641 34.8671 36.5967 39.0186 36.9296 39.5866 37.1969 40.1906 37.3938 40.8187L41.8937 43.2 41.8937 45C41.8937 46.3807 43.0131 47.5 44.3937 47.5 45.7744 47.5 46.8937 46.3807 46.8937 45L46.8937 41.6937C46.9071 40.7797 46.4206 39.9313 45.625 39.4812L38.0063 35.4562C41.25 32.5938 44 30.8562 45 26.6562 45.261 25.0859 45.2036 23.479 44.8313 21.9312 44.8313 21.4929 45.1866 21.1375 45.625 21.1375L52.05 21.1375C52.4141 21.1331 52.7711 21.0363 53.0875 20.8562 55.2812 19.5688 55.3 16.8188 55.25 15.9625 55.2373 15.7966 55.1764 15.6381 55.075 15.5062L53.05 12.9625 53.05 12.9625C53.05 8.44375 49.375 5.55625 44.8562 5.54375 40.3904 5.45916 36.7016 9.01081 36.6171 13.4766 36.6114 13.7765 36.6224 14.0764 36.65 14.375 36.6917 14.9014 36.3695 15.3886 35.8688 15.5562 19.1187 21.4062 16.5437 34.7313 16.4 41.5375 14.8312 41.2812 14.8187 40.725 14.8187 39.9375L14.8187 18.6875C14.8187 15.9261 12.5802 13.6875 9.81875 13.6875 7.05731 13.6875 4.81875 15.9261 4.81875 18.6875L4.81875 21.425C4.81875 22.4606 5.65822 23.3 6.69375 23.3 7.72931 23.3 8.56875 22.4606 8.56875 21.425L8.56875 18.75C8.56875 18.0596 9.12838 17.5 9.81875 17.5 10.5091 17.5 11.0687 18.0596 11.0687 18.75L11.0687 40C11.0687 44.1625 14.1937 45.175 16.8 45.4187 18 49.925 22.0938 53.4937 30.9937 53.6875Z",
    fill: "#002060",
    transform: "matrix(1.05 0 0 1 266 517)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.7438 53.6375 38.9688 53.6375C40.3494 53.6375 41.4688 52.5182 41.4688 51.1375 41.4688 49.7568 40.3494 48.6375 38.9688 48.6375L33.925 48.6375C36.7245 45.9066 36.7802 41.4234 34.0493 38.6239 32.7032 37.2439 30.8527 36.4724 28.925 36.4875 26.625 36.55 25.7063 37.4437 25.1125 37.625 24.6383 37.7346 24.1643 37.4418 24.05 36.9688 23.9744 36.5101 24.2374 36.0631 24.675 35.9062 28.8266 33.4736 34.1641 34.8671 36.5967 39.0186 36.9296 39.5866 37.1969 40.1906 37.3938 40.8187L41.8937 43.2 41.8937 45C41.8937 46.3807 43.0131 47.5 44.3937 47.5 45.7744 47.5 46.8937 46.3807 46.8937 45L46.8937 41.6937C46.9071 40.7797 46.4206 39.9313 45.625 39.4812L38.0063 35.4562C41.25 32.5938 44 30.8562 45 26.6562 45.261 25.0859 45.2036 23.479 44.8313 21.9312 44.8313 21.4929 45.1866 21.1375 45.625 21.1375L52.05 21.1375C52.4141 21.1331 52.7711 21.0363 53.0875 20.8562 55.2812 19.5688 55.3 16.8188 55.25 15.9625 55.2373 15.7966 55.1764 15.6381 55.075 15.5062L53.05 12.9625 53.05 12.9625C53.05 8.44375 49.375 5.55625 44.8562 5.54375 40.3904 5.45916 36.7016 9.01081 36.6171 13.4766 36.6114 13.7765 36.6224 14.0764 36.65 14.375 36.6917 14.9014 36.3695 15.3886 35.8688 15.5562 19.1187 21.4062 16.5437 34.7313 16.4 41.5375 14.8312 41.2812 14.8187 40.725 14.8187 39.9375L14.8187 18.6875C14.8187 15.9261 12.5802 13.6875 9.81875 13.6875 7.05731 13.6875 4.81875 15.9261 4.81875 18.6875L4.81875 21.425C4.81875 22.4606 5.65822 23.3 6.69375 23.3 7.72931 23.3 8.56875 22.4606 8.56875 21.425L8.56875 18.75C8.56875 18.0596 9.12838 17.5 9.81875 17.5 10.5091 17.5 11.0687 18.0596 11.0687 18.75L11.0687 40C11.0687 44.1625 14.1937 45.175 16.8 45.4187 18 49.925 22.0938 53.4937 30.9937 53.6875Z",
    fill: "#C00000",
    transform: "matrix(1.03333 0 0 1 107 468)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.2728 54.5315 39.6182 54.5315C41.0219 54.5315 42.1599 53.3935 42.1599 51.9898 42.1599 50.5861 41.0219 49.4481 39.6182 49.4481L34.4904 49.4481C37.3366 46.6717 37.3932 42.1138 34.6168 39.2676 33.2482 37.8647 31.3669 37.0803 29.4071 37.0956 27.0688 37.1592 26.1347 38.0678 25.531 38.2521 25.049 38.3635 24.5671 38.0658 24.4508 37.5849 24.374 37.1186 24.6414 36.6641 25.0863 36.5047 29.307 34.0315 34.7335 35.4482 37.2067 39.6689 37.5451 40.2464 37.8169 40.8604 38.017 41.4991L42.592 43.92 42.592 45.75C42.592 47.1537 43.7299 48.2917 45.1336 48.2917 46.5373 48.2917 47.6753 47.1537 47.6753 45.75L47.6753 42.3886C47.6889 41.4594 47.1943 40.5968 46.3854 40.1393L38.6397 36.0472C41.9375 33.137 44.7333 31.3705 45.75 27.1005 46.0154 25.504 45.957 23.8703 45.5784 22.2968 45.5784 21.8511 45.9397 21.4898 46.3854 21.4898L52.9175 21.4898C53.2876 21.4853 53.6506 21.3869 53.9723 21.2039 56.2026 19.8949 56.2217 17.0991 56.1708 16.2285 56.1579 16.0599 56.0961 15.8988 55.9929 15.7647L53.9342 13.1785 53.9342 13.1785C53.9342 8.58448 50.1979 5.64885 45.6039 5.63615 41.0636 5.55015 37.3133 9.16099 37.2273 13.7012 37.2216 14.0061 37.2327 14.311 37.2608 14.6146 37.3032 15.1498 36.9757 15.645 36.4666 15.8155 19.4374 21.763 16.8195 35.3101 16.6733 42.2298 15.0784 41.9693 15.0657 41.4038 15.0657 40.6031L15.0657 18.999C15.0657 16.1915 12.7899 13.9156 9.9824 13.9156 7.17493 13.9156 4.89906 16.1915 4.89906 18.999L4.89906 21.7821C4.89906 22.8349 5.75252 23.6883 6.80531 23.6883 7.85813 23.6883 8.71156 22.8349 8.71156 21.7821L8.71156 19.0625C8.71156 18.3606 9.28051 17.7917 9.9824 17.7917 10.6843 17.7917 11.2532 18.3606 11.2532 19.0625L11.2532 40.6667C11.2532 44.8985 14.4303 45.9279 17.08 46.1757 18.3 50.7571 22.462 54.3853 31.5103 54.5823Z",
    fill: "#78206E",
    transform: "matrix(1.01639 0 0 1 107 271)"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#fx0)",
    transform: "translate(780 199)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.79822 9.39632 70.555 9.39632 70.555 67.8158 8.79822 67.8158Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.555 9.39632 132.312 9.39632 132.312 67.8158 70.555 67.8158Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.312 9.39632 194.068 9.39632 194.068 67.8158 132.312 67.8158Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.068 9.39632 255.825 9.39632 255.825 67.8158 194.068 67.8158Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.825 9.39632 317.582 9.39632 317.582 67.8158 255.825 67.8158Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.582 9.39632 379.339 9.39632 379.339 67.8158 317.582 67.8158Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79822 67.8158 70.555 67.8158 70.555 126.369 8.79822 126.369Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.555 67.8158 132.312 67.8158 132.312 126.369 70.555 126.369Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.312 67.8158 194.068 67.8158 194.068 126.369 132.312 126.369Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.068 67.8158 255.825 67.8158 255.825 126.369 194.068 126.369Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.825 67.8158 317.582 67.8158 317.582 126.369 255.825 126.369Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.582 67.8158 379.339 67.8158 379.339 126.369 317.582 126.369Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79822 126.369 70.555 126.369 70.555 184.789 8.79822 184.789Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.555 126.369 132.312 126.369 132.312 184.789 70.555 184.789Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.312 126.369 194.068 126.369 194.068 184.789 132.312 184.789Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.068 126.369 255.825 126.369 255.825 184.789 194.068 184.789Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.825 126.369 317.582 126.369 317.582 184.789 255.825 184.789Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.582 126.369 379.339 126.369 379.339 184.789 317.582 184.789Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79822 184.789 70.555 184.789 70.555 243.208 8.79822 243.208Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.555 184.789 132.312 184.789 132.312 243.208 70.555 243.208Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.312 184.789 194.068 184.789 194.068 243.208 132.312 243.208Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.068 184.789 255.825 184.789 255.825 243.208 194.068 243.208Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.825 184.789 317.582 184.789 317.582 243.208 255.825 243.208Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.582 184.789 379.339 184.789 379.339 243.208 317.582 243.208Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79822 243.208 70.555 243.208 70.555 301.628 8.79822 301.628Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.555 243.208 132.312 243.208 132.312 301.628 70.555 301.628Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.312 243.208 194.068 243.208 194.068 301.628 132.312 301.628Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.068 243.208 255.825 243.208 255.825 301.628 194.068 301.628Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.825 243.208 317.582 243.208 317.582 301.628 255.825 301.628Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.582 243.208 379.339 243.208 379.339 301.628 317.582 301.628Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79822 301.628 70.555 301.628 70.555 360.047 8.79822 360.047Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.555 301.628 132.312 301.628 132.312 360.047 70.555 360.047Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.312 301.628 194.068 301.628 194.068 360.047 132.312 360.047Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.068 301.628 255.825 301.628 255.825 360.047 194.068 360.047Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.825 301.628 317.582 301.628 317.582 360.047 255.825 360.047Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.582 301.628 379.339 301.628 379.339 360.047 317.582 360.047Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.555 7.39632 70.555 362.047",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.312 7.39632 132.312 362.047",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.068 7.39632 194.068 362.047",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.825 7.39632 255.825 362.047",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.582 7.39632 317.582 362.047",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79822 67.8158 381.339 67.8158",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79822 126.369 381.339 126.369",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79822 184.789 381.339 184.789",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79822 243.208 381.339 243.208",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79822 301.628 381.339 301.628",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79822 7.39632 8.79822 362.047",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.339 7.39632 379.339 362.047",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79822 9.39632 381.339 9.39632",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79822 360.047 381.339 360.047",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M796.341 215.939 858.097 215.939 858.097 274.358 796.341 274.358Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.097 215.939 919.854 215.939 919.854 274.358 858.097 274.358Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.854 215.939 981.611 215.939 981.611 274.358 919.854 274.358Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.611 215.939 1043.37 215.939 1043.37 274.358 981.611 274.358Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.37 215.939 1105.12 215.939 1105.12 274.358 1043.37 274.358Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.12 215.939 1166.88 215.939 1166.88 274.358 1105.12 274.358Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.341 274.358 858.097 274.358 858.097 332.912 796.341 332.912Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.097 274.358 919.854 274.358 919.854 332.912 858.097 332.912Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.854 274.358 981.611 274.358 981.611 332.912 919.854 332.912Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.611 274.358 1043.37 274.358 1043.37 332.912 981.611 332.912Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.37 274.358 1105.12 274.358 1105.12 332.912 1043.37 332.912Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.12 274.358 1166.88 274.358 1166.88 332.912 1105.12 332.912Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.341 332.912 858.097 332.912 858.097 391.331 796.341 391.331Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.097 332.912 919.854 332.912 919.854 391.331 858.097 391.331Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.854 332.912 981.611 332.912 981.611 391.331 919.854 391.331Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.611 332.912 1043.37 332.912 1043.37 391.331 981.611 391.331Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.37 332.912 1105.12 332.912 1105.12 391.331 1043.37 391.331Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.12 332.912 1166.88 332.912 1166.88 391.331 1105.12 391.331Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.341 391.331 858.097 391.331 858.097 449.751 796.341 449.751Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.097 391.331 919.854 391.331 919.854 449.751 858.097 449.751Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.854 391.331 981.611 391.331 981.611 449.751 919.854 449.751Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.611 391.331 1043.37 391.331 1043.37 449.751 981.611 449.751Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.37 391.331 1105.12 391.331 1105.12 449.751 1043.37 449.751Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.12 391.331 1166.88 391.331 1166.88 449.751 1105.12 449.751Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.341 449.751 858.097 449.751 858.097 508.17 796.341 508.17Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.097 449.751 919.854 449.751 919.854 508.17 858.097 508.17Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.854 449.751 981.611 449.751 981.611 508.17 919.854 508.17Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.611 449.751 1043.37 449.751 1043.37 508.17 981.611 508.17Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.37 449.751 1105.12 449.751 1105.12 508.17 1043.37 508.17Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.12 449.751 1166.88 449.751 1166.88 508.17 1105.12 508.17Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.341 508.17 858.097 508.17 858.097 566.59 796.341 566.59Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.097 508.17 919.854 508.17 919.854 566.59 858.097 566.59Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.854 508.17 981.611 508.17 981.611 566.59 919.854 566.59Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.611 508.17 1043.37 508.17 1043.37 566.59 981.611 566.59Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.37 508.17 1105.12 508.17 1105.12 566.59 1043.37 566.59Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.12 508.17 1166.88 508.17 1166.88 566.59 1105.12 566.59Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.097 213.939 858.097 568.59",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.854 213.939 919.854 568.59",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.611 213.939 981.611 568.59",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.37 213.939 1043.37 568.59",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.12 213.939 1105.12 568.59",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.341 274.358 1168.88 274.358",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.341 332.912 1168.88 332.912",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.341 391.331 1168.88 391.331",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.341 449.751 1168.88 449.751",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.341 508.17 1168.88 508.17",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.341 213.939 796.341 568.59",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.88 213.939 1166.88 568.59",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.341 215.939 1168.88 215.939",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.341 566.59 1168.88 566.59",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#fx1)",
    transform: "translate(548 308)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.82849 42.3285 151.829 42.3285 151.829 7.46449 219.692 75.3286 151.829 143.192 151.829 108.328 6.82849 108.328ZM8.62849 106.528 153.629 106.528 153.629 138.847 217.147 75.3286 153.629 11.8101 153.629 44.1285 8.62849 44.1285ZM10.4285 45.9285 155.429 45.9285 155.429 16.1557 214.601 75.3286 155.429 134.501 155.429 104.728 10.4285 104.728ZM15.8285 99.3284 160.829 99.3284 160.829 121.465 206.965 75.3286 160.829 29.1925 160.829 51.3285 15.8285 51.3285Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M552 347.5 697 347.5 697 312.636 764.864 380.5 697 448.364 697 413.5 552 413.5ZM553.8 411.7 698.8 411.7 698.8 444.018 762.318 380.5 698.8 316.982 698.8 349.3 553.8 349.3ZM555.6 351.1 700.6 351.1 700.6 321.327 759.773 380.5 700.6 439.673 700.6 409.9 555.6 409.9ZM561 404.5 706 404.5 706 426.636 752.136 380.5 706 334.364 706 356.5 561 356.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigration);
export default __webpack_public_path__ + "static/media/Migration.987af52bb81fe2506227b16ba5c195c6.svg";
export { ForwardRef as ReactComponent };